// @flow
import React from "react";
import { css } from "react-emotion";
import { Link } from "react-router-dom";
import Header from "./subcomponents/Header";
import logo from "assets/images/app_logo.svg";

class PanelWrapper extends React.Component {
  constructor() {
    super();
    this.state = {
      open: true,
    };
  }

  toggle = () => {
    this.setState(p => ({
      open: !p.open,
    }));
  };

  render() {
    const { open } = this.state;
    const { children } = this.props;

    return (
      <div className="body body-wrapper">
        <div className="body-wrapper-inner">
          <nav className="nav-leftpanel">
            <div className="app-logo-container">
              <Link to="/">
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="nav-leftpanel--links-list" id="left-panel-portal" />
          </nav>
          <div className={`main-content-wrapper ${open ? "" : closedContent}`}>
            <Header open={open} toggle={this.toggle} />
            <div className="main-content-wrapper--inner">{children}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default PanelWrapper;

const closedContent = css`
  margin-left: 20px;
  width: calc(100% - 20px);
`;



// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/PanelWrapper.jsx